import { createStyles, Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
  createStyles({
    container: {
      borderTop: 'none',
      width: '100%',
    },
    root: { borderRight: `1px solid ${theme.palette.grey[200]}` },
    wrapper: {
      flexDirection: 'row',
      alignItems: 'center',
      justify: 'space-between',
      padding: theme.spacing(1, 0),
    },
    paper: {
      width: '100%',
    },
    tab: {
      margin: theme.spacing(0, 1, 0, 0),
    },
  });

export default styles;
